import React, { useState } from "react";
import AssetNavbar from "../../AssetFailuer/AssetNavbar";
import AFController from "../../AssetFailuer/AFController";
import { flattenData } from "../../../Utilitie";
import LTSummaryController from "./LTSummaryController";
import LTYearWiseData from "./LTYearWiseData";
import LTCategoryWiseSummary from "./LTCategoryWiseSummary";
import LTTrainWiseSummary from "./LTTrainWiseSummary";

const LTSummaryMaster = () => {
  const [filteredAF, setFilteredAF] = useState(null);
  const [aFData, setAFData] = useState(null);
  const [act, setAct] = useState("Year Wise");

  const [openStates, setOpenStates] = useState({
    Year: "",
    detention_grp: "",
    group_code: "",
    sub_group_code: "",
    Month: "",
    section: "",
    trainNo: "",
  });
  const [treeMapPath, setTreeMapPath] = useState({
    Year: "",
    detention_grp: "",
    group_code: "",
    sub_group_code: "",
    Month: "",
    section: "",
    trainNo: "",
  });
  const tempData = filteredAF;
  const year = [...new Set(tempData && tempData.map((t) => t.F_YEAR))].sort(
    (a, b) => Number(a.replace("_", "")) - Number(b.replace("_", "")),
  );

  return (
    <div>
      <div className="sticky-controller">
        <LTSummaryController
          openStates={openStates}
          setFilteredAF={setFilteredAF}
          setOpenStates={setOpenStates}
          setAFData={setAFData}
        />
      </div>
      {/* ////////////////////////////////////////////////////////////////////////////////////////// */}
      <div className="d-flex justify-content-center my-3">
        <div
          className="position-relative d-flex rounded-pill border bg-light"
          style={{ width: "360px", height: "42px" }}
        >
          <div
            className="position-absolute top-0 h-100 rounded-pill "
            style={{
              backgroundColor: "#87CEEB",
              width: "33.33%",
              transition: "0.3s",
              transform:
                act === "Year Wise"
                  ? "translateX(0%)"
                  : act === "Month Wise"
                    ? "translateX(100%)"
                    : "translateX(200%)",
            }}
          />

          {["Year Wise", "Month Wise", "Train Wise"].map((item) => (
            <div
              key={item}
              className={`flex-fill d-flex align-items-center justify-content-center fw-semibold position-relative ${
                act === item ? "text-white" : "text-dark"
              }`}
              onClick={() => setAct(item)}
              style={{ cursor: "pointer" }}
            >
              {item}
            </div>
          ))}
        </div>
      </div>
      {act === "Year Wise" && (
        <div>
          <LTYearWiseData data={filteredAF} more={{ years: year }} />{" "}
        </div>
      )}
      {act === "Month Wise" && (
        <div>
          {filteredAF && year.length > 0 && (
            <LTCategoryWiseSummary
              data={filteredAF}
              more={{ years: year }}
              year={year}
            />
          )}
        </div>
      )}
      {act === "Train Wise" && (
        <div>
          {filteredAF && year.length > 0 && (
            <LTTrainWiseSummary
              data={filteredAF}
              more={{ years: year }}
              year={year}
            />
          )}
        </div>
      )}
      <div
        style={{ minHeight: "90vh" }}
        onClick={() => {
          setOpenStates({
            Year: false,
            detention_grp: false,
            group_code: false,
            sub_group_code: false,
            Month: false,
            section: false,
            trainNo: false,
          });
        }}
      ></div>{" "}
    </div>
  );
};
export default LTSummaryMaster;
